/**
 * Seeded classifier UUIDs. Source of truth lives in
 * `packages/backend/prisma/seed/classifiers.ts` — these values must stay in
 * lockstep with the seed.
 */
export const VALUATION_PERSON_INPUT_CLASSIFIERS = {
	RECEIVABLES: 'aa116762-b9f4-4766-9f8f-4fe555679db8',
	CASH_ON_BALANCE_SHEET: 'eb3a7da2-8cfd-48df-a98f-68d6ffa6dcb0',
	PAYABLES: '6535c7e1-7f12-40d6-aea0-4132485b51c7',
	RETAINED_CASH_AND_HOLDBACKS: 'a9654853-d020-4329-9d9c-833f2f9ebff1',
} as const;

export const VALUATION_ADJUSTMENT_CLASSIFIERS = {
	CASH: 'c9e1dd9c-52c2-4c14-92c2-676bce753c4c',
	WORKING_CAPITAL: '23a10716-8d99-483b-b3a4-0158445bb0aa',
} as const;
